import { Link } from "react-router-dom";
import { KeyRound, Building2, Mail, ShieldCheck, CreditCard, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/saas/AuthContext";
import { SupportLine } from "@/components/SupportLine";
import { useI18n, usePageTitle } from "@/i18n";

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-3 border-b border-re-line py-3 last:border-0">
      <Icon className="h-4 w-4 text-re-red" />
      <span className="w-36 text-sm text-re-muted">{label}</span>
      <span className="truncate text-sm font-medium text-re-charcoal">{value || "—"}</span>
    </div>
  );
}

export default function Account() {
  const { user, org } = useAuth();
  const { t } = useI18n();
  usePageTitle("titles.account");
  return (
    <div className="max-w-xl space-y-6" data-testid="account-page">
      <h1 className="font-heading text-2xl font-bold text-re-charcoal">{t("acct.title")}</h1>

      <div className="rounded-2xl border border-re-line bg-white p-6">
        <h2 className="mb-1 font-heading text-sm font-semibold uppercase tracking-wide text-re-muted">{t("acct.personal")}</h2>
        <Row icon={Mail} label={t("acct.email")} value={user?.email} />
        <Row icon={ShieldCheck} label={t("acct.role")} value={user?.role === "AGENCY_ADMIN" ? t("acct.administrator") : t("acct.user")} />
        <h2 className="mb-1 mt-5 font-heading text-sm font-semibold uppercase tracking-wide text-re-muted">{t("acct.organisation")}</h2>
        <Row icon={Building2} label={t("acct.organisation")} value={org?.name} />
      </div>

      <div className="flex flex-col gap-3 sm:flex-row">
        <Link to="/account/billing" data-testid="go-billing" className="flex-1">
          <Button variant="outline" className="w-full justify-between rounded-full"><span className="flex items-center"><CreditCard className="mr-2 h-4 w-4 text-re-red" /> {t("acct.billing")}</span><ChevronRight className="h-4 w-4" /></Button>
        </Link>
        <Link to="/account/password" data-testid="go-change-password" className="flex-1">
          <Button variant="outline" className="w-full justify-between rounded-full"><span className="flex items-center"><KeyRound className="mr-2 h-4 w-4 text-re-red" /> {t("acct.password")}</span><ChevronRight className="h-4 w-4" /></Button>
        </Link>
      </div>

      <SupportLine testid="account-support" />
    </div>
  );
}
